import React, { useEffect } from 'react';
import { Button, Col, Form, FormGroup, Label } from 'reactstrap';
import { Field, reduxForm, change } from 'redux-form';
import moment from 'moment';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import ValidatedInput from "../../../components/ValidatedInput";

const AccountOwnerDOB = ({ nextStep, prevStep, handleSubmit, active, processing, secondary, investAccount, dispatch }) => {

    useEffect(() => {
        if (active && investAccount && investAccount.id) {
            if (secondary) {
                let date_of_birth = investAccount.secondary_account_owner_date_of_birth || null;
                if(date_of_birth){
                    date_of_birth = moment(investAccount.secondary_account_owner_date_of_birth).format('MM/DD/YYYY');
                }
                dispatch(change('AccountOwnerDOBForm', 'date_of_birth', date_of_birth));
            } else {
                let date_of_birth = investAccount.primary_account_owner_date_of_birth || null;
                if(date_of_birth){
                    date_of_birth = moment(investAccount.primary_account_owner_date_of_birth).format('MM/DD/YYYY');
                }
                dispatch(change('AccountOwnerDOBForm', 'date_of_birth', date_of_birth || null));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active, investAccount]);

    const handleNext = (formData) => {
        let payload = {};
        if (secondary) {
            payload.secondary_account_owner_date_of_birth = formData.date_of_birth;
        } else {
            payload.primary_account_owner_date_of_birth = formData.date_of_birth;
        }
        nextStep(payload);
    };

    const getMaxDate = () => {
        const current = new Date();
        return new Date(current).setYear(current.getFullYear() - 18);
    };

    const handleBack = () => {
        prevStep();
    }

    return (
        <div className={`account-setup-wrapper ${!active ? 'd-none' : ''}`}>
            <Form className="form-container" onSubmit={handleSubmit(handleNext)}>
                <div className="back-btn">
                    <Button color="link" onClick={handleBack}>back</Button>
                </div>
                <div className="form-header mt-md-3 mt-0">
                    <h2>{secondary ? 'SECONDARY' : 'PRIMARY'} ACCOUNT OWNER</h2>
                    <span>What's the Date of Birth of the {secondary ? 'secondary' : 'primary'} owner?</span>
                </div>
                <div className="account-info-container">
                    <FormGroup row>
                        <Label sm={4}>Date of Birth</Label>
                        <Col sm={7}>
                            <Field
                                component={ValidatedInput}
                                type="date"
                                maxDate={getMaxDate()}
                                name="date_of_birth"
                                placeholder="Date of Birth" />
                        </Col>
                    </FormGroup>
                </div>
                <div className="button_wrapper">
                    <button className="custom-btn-primary" type="submit" disabled={processing}>
                        NEXT STEP {processing && <FontAwesomeIcon icon={faSpinner} spin />}
                    </button>
                </div>
            </Form>
        </div>
    )
};

const validate = (values) => {
    const errors = {};
    if (!values.date_of_birth) {
        errors.date_of_birth = 'Field is required';
    }
    return errors;
};

export default reduxForm({
    form: 'AccountOwnerDOBForm',
    validate,
})(AccountOwnerDOB);
